import React, { useState, useEffect } from "react";
import moment from 'moment'

function ActiveSubBlock(props) {
  const {
    plan_type,
    stripe_id,
    subscription_amount,
    current_period_end,
    account,
    subscription
  } = props;
  const [charge_failed, setChargeFailed] = useState(false);
  const [permissions, setPermissions] = useState({
    isAdmin: false,
    role: null,
    canEditLiveWindow: false,
  });
  const [trial, setTrial] = useState({
    trial_start: subscription.trial_start ? subscription.trial_start : null,
    trial_end: subscription.trial_end ? subscription.trial_end : null
  })

  useEffect(() => {
    if (account) {
      const perms = account && account.permissions ? account.permissions : null;

      function search(id, myArray) {
        for (var i = 0; i < myArray.length; i++) {
          if (myArray[i].user_id === id) {
            return myArray[i];
          }
        }
      }

      if (perms) {
        const gm_permissions = search(props.uid, perms);
        if (gm_permissions) {
          setPermissions(gm_permissions);
        }
      } else {
        setPermissions({ isAdmin: true });
      }
    }

    if (account) {
      const subscription_status_type = account && account && account.subscription_status 
        ? account.subscription_status.type
        : null;
      // Set Charge Failed
      if (subscription_status_type === "charge.failed") setChargeFailed(true);
    }
  }, [account]);

  useEffect(()=> {

    if (subscription){
      setTrial({
        trial_start: subscription.trial_start ? subscription.trial_start : null,
        trial_end: subscription.trial_end ? subscription.trial_end : null
      })
    }

  }, [subscription])

  const checkUserPermissions = () => {
    const account = props.account;
    const permissions =
      account && account.permissions ? account.permissions : null;

    function search(id, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (myArray[i].user_id === id) {
          return myArray[i];
        }
      }
    }

    if (permissions) {
      const gm_permissions = search(props.uid, permissions);
      if (gm_permissions) return gm_permissions;
    } else {
      return { isAdmin: true };
    }
  };

  console.log('trial', trial)

  return (
    <div>
      {charge_failed && (
        <div style={{ marginBottom: "10px" }}>
          <div
            class="alert alert-danger d-flex align-items-center"
            role="alert"
            style={{ justifyContent: "space-between" }}
          >
            <div>
              <svg
                width="24px"
                fill="currentColor"
                style={{ marginRight: "10px" }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path d="M96 360C96 346.7 106.7 336 120 336H168C181.3 336 192 346.7 192 360C192 373.3 181.3 384 168 384H120C106.7 384 96 373.3 96 360zM224 360C224 346.7 234.7 336 248 336H360C373.3 336 384 346.7 384 360C384 373.3 373.3 384 360 384H248C234.7 384 224 373.3 224 360zM96 280C96 266.7 106.7 256 120 256H456C469.3 256 480 266.7 480 280C480 293.3 469.3 304 456 304H120C106.7 304 96 293.3 96 280zM456 128C469.3 128 480 138.7 480 152V200C480 213.3 469.3 224 456 224H376C362.7 224 352 213.3 352 200V152C352 138.7 362.7 128 376 128H456zM0 96C0 60.65 28.65 32 64 32H512C547.3 32 576 60.65 576 96V416C576 451.3 547.3 480 512 480H64C28.65 480 0 451.3 0 416V96zM48 96V416C48 424.8 55.16 432 64 432H512C520.8 432 528 424.8 528 416V96C528 87.16 520.8 80 512 80H64C55.16 80 48 87.16 48 96z" />
              </svg>{" "}
              <b>Payment Failed</b>
              <span style={{ marginLeft: "5px" }}>
                {" "}
                Please update your payment method.
              </span>
            </div>

          </div>
        </div>
      )}
    
    <div class="billing-subscription-block">
  
      <div class="div-block-13">
        <div>
        {trial.trial_end && (
          <h5 style={{color:'#0168fa'}}><i class="fa-solid fa-sparkles" style={{marginRight:'5px'}}></i> Free trial ends on {moment(trial.trial_end * 1000).format('ll')}</h5>
        )}
        <h2 class="heading-5">Your monthly subscription - {plan_type()}</h2>

        </div>

        {checkUserPermissions().role === "Admin" ? (
          <form
            method="POST"
            action="https://us-central1-escaperoomwaiver-v2.cloudfunctions.net/stripeCustomerPortal"
          >
            <input
              name="customer_id"
              id="customer_id"
              value={stripe_id}
              style={{ display: "none" }}
            />
            <button
              type="submit"
              className="account-button-blue w-button"
              style={{ border: "none", fontWeight: "500" }}
            >
              {charge_failed ? 'Update Payment Method' : 'Manage Subscription'}
            </button>
          </form>
        ) : null}
      </div>
      <ul role="list">
        <li>
          {plan_type() === "Starter Plan" && (
            <p className="paragraph-9">1 game rooms</p>
          )}
          {plan_type() === "Unlimited" && (
            <p className="paragraph-9">Unlimited Rooms</p>
          )}
          {plan_type() === "Scale Plan" && (
            <p className="paragraph-9">10 game rooms</p>
          )}
        </li>
        <li>
          {trial.trial_end ? (
          <div>
            <p className="paragraph-10">Free Trial</p>
            <p style={{color:'#7d829c'}}>You'll be charged ${subscription_amount / 100}/mo starting {moment(trial.trial_end * 1000).format('ll')}</p>
          </div>
        ): (<p className="paragraph-10">${subscription_amount / 100}/mo</p>)}
        </li>
      </ul>
      

      {trial.trial_end ? (
        <p class="paragraph-11">
        Your first payment is on <strong>{current_period_end}</strong>
      </p>
      ): <p class="paragraph-11">
      Your next payment is on <strong>{current_period_end}</strong>
    </p>}

      
    </div>
    </div>
  );
}

export default ActiveSubBlock;
